// extracted by mini-css-extract-plugin
export default {"tableRow":"InspectionsHistory_tableRow__xk10G"};